import React, { useState } from 'react';

import QuillEditor from 'components/QuillEditor/QuillEditorEmail';
import InformationModal from 'components/Modals/informationModal';
import Dropdown from 'components/Dropdown/Dropdown';
import { Checkbox } from 'components/Checkbox/Checkbox';
import {
  ITag,
  ButtonContainer,
  InputField,
  DescriptionContainer,
  EmptyContainer,
  Label,
  TestFieldsContainer,
  FieldContainer,
} from './styles';
import { useMultichoiceCreatorContext } from 'hooks/useContext';

export default React.memo(() => {
  const { test, setTest } = useMultichoiceCreatorContext();
  const [showInformationModal, setShowInformationModal] = useState(false);

  return (
    <>
      {showInformationModal && (
        <InformationModal
          title="Info on adaptive test"
          textHTML={test.adaptiveTestInfo}
          closeModal={() => setShowInformationModal(false)}
        />
      )}
      <InputField
        type="text"
        placeholder="Test name"
        value={test.name}
        onChange={(e) => setTest({ ...test, name: e.target.value })}
      />
      <DescriptionContainer>
        <EmptyContainer>
          <Label>Description for Company</Label>
          <QuillEditor
            placeholder="Description for company"
            className="quill-company-description"
            height="325px"
            value={test.description}
            onChange={(updatedValue, delta, source) => {
              if (source === 'user') setTest({ ...test, description: updatedValue });
            }}
          />
        </EmptyContainer>
        <EmptyContainer>
          <Label>Description for Candidate</Label>
          <QuillEditor
            placeholder="Description for candidate"
            className="quill-candidate-description"
            height="325px"
            value={test.candidateDescription}
            onChange={(updatedValue, delta, source) => {
              if (source === 'user') setTest({ ...test, candidateDescription: updatedValue });
            }}
          />
        </EmptyContainer>
      </DescriptionContainer>
      <TestFieldsContainer>
        {test.adaptiveTest && (
          <FieldContainer>
            <Label>Total Questions</Label>
            <InputField
              type="number"
              value={test.scale}
              onChange={(e) => setTest({ ...test, scale: e.target.value })}
            />
          </FieldContainer>
        )}
        <FieldContainer>
          <Label>Time Limit</Label>
          <InputField
            type="number"
            value={test.duration}
            onChange={(e) => setTest({ ...test, duration: e.target.value })}
          />
        </FieldContainer>
        <FieldContainer>
          <Label>Price</Label>
          <InputField type="number" value={test.price} onChange={(e) => setTest({ ...test, price: e.target.value })} />
        </FieldContainer>
        <FieldContainer>
          <Label>Difficulty</Label>
          <Dropdown
            options={[
              { label: 'Junior', value: 'Junior' },
              { label: 'Mid-level', value: 'Mid-level' },
              { label: 'Senior', value: 'Senior' },
            ]}
            value={test.difficulty}
            onChange={(response) => setTest({ ...test, difficulty: response.value })}
          />
        </FieldContainer>
        <ButtonContainer>
          <Checkbox
            checked={test.adaptiveTest}
            label="Adaptive Test"
            onChange={() => setTest({ ...test, adaptiveTest: !test.adaptiveTest })}
          ></Checkbox>
          <ITag className="fa fa-info-circle" onClick={() => setShowInformationModal(true)} />
        </ButtonContainer>
      </TestFieldsContainer>
    </>
  );
});
